/**
 * Fancy Product Designer concatenates every view into one JPEG on download.
 * Duplicate Front views on 2-color pointed stoles stacked three images.
 *
 * Do not scan window keys or observe the whole DOM: Shopify pixel iframes
 * throw SecurityError and that abort Add to cart.
 */
(function () {
  var collapsing = false;
  var patched = false;

  function getFpd() {
    try {
      if (window.fpd && window.fpd.instance && Array.isArray(window.fpd.instance.viewInstances)) {
        return window.fpd.instance;
      }
    } catch (e) {
      /* ignore */
    }
    try {
      if (window.fancyProductDesigner && Array.isArray(window.fancyProductDesigner.viewInstances)) {
        return window.fancyProductDesigner;
      }
    } catch (e) {
      /* ignore */
    }
    try {
      var hosts = document.querySelectorAll('fancy-product-designer, fpd-element, .fpd-container');
      for (var i = 0; i < hosts.length; i++) {
        var host = hosts[i];
        var candidates = [host.fpd, host.__fpd, host.fancyProductDesigner, host._fpd];
        for (var c = 0; c < candidates.length; c++) {
          if (candidates[c] && Array.isArray(candidates[c].viewInstances)) return candidates[c];
        }
      }
    } catch (e) {
      /* ignore */
    }
    return null;
  }

  function viewInstances(fpd) {
    try {
      return fpd && Array.isArray(fpd.viewInstances) ? fpd.viewInstances : [];
    } catch (e) {
      return [];
    }
  }

  function viewTitle(view) {
    if (!view) return '';
    return String(view.title || view.name || '').trim();
  }

  function hasDuplicateFrontViews(fpd) {
    var views = viewInstances(fpd);
    if (views.length <= 1) return false;
    return views.every(function (view) {
      var title = viewTitle(view).toLowerCase().replace(/\s+/g, ' ');
      return title === '' || title.indexOf('front') === 0;
    });
  }

  function currentIndex(fpd) {
    if (typeof fpd.currentViewIndex === 'number' && fpd.currentViewIndex >= 0) {
      return fpd.currentViewIndex;
    }
    return 0;
  }

  function collapseExtraViews() {
    if (collapsing) return;
    var fpd = getFpd();
    if (!fpd || !hasDuplicateFrontViews(fpd)) return;

    collapsing = true;
    try {
      var keep = currentIndex(fpd);
      var views = viewInstances(fpd);
      if (keep < 0 || keep >= views.length) keep = 0;

      if (typeof fpd.removeView === 'function') {
        for (var i = views.length - 1; i >= 0; i--) {
          if (i === keep) continue;
          try {
            fpd.removeView(i);
          } catch (e) {
            /* FPD may reject removeView while switching products */
          }
        }
      }
    } catch (e) {
      /* never block designer or cart */
    } finally {
      collapsing = false;
    }
  }

  function patchExport() {
    var fpd = getFpd();
    if (!fpd || patched || typeof fpd.getProductDataURL !== 'function') return;
    patched = true;

    var original = fpd.getProductDataURL.bind(fpd);
    fpd.getProductDataURL = function (callback, options, viewRange) {
      try {
        if (hasDuplicateFrontViews(fpd)) {
          collapseExtraViews();
          var idx = currentIndex(fpd);
          return original(callback, options, [idx, idx]);
        }
      } catch (e) {
        /* fall through to original export */
      }
      return original(callback, options, viewRange);
    };
  }

  function run() {
    try {
      collapseExtraViews();
      patchExport();
    } catch (e) {
      /* never throw into page event handlers */
    }
  }

  function isDownloadControl(node) {
    if (!(node instanceof Element)) return false;
    if (node.closest('[data-context="download"], [data-action="download"]')) return true;
    if (node.closest('.fpd-icon-download, .fpd-download, [title="Download"]')) return true;
    var label = (node.getAttribute('title') || node.getAttribute('aria-label') || node.textContent || '')
      .trim()
      .toLowerCase();
    return label === 'download';
  }

  document.addEventListener(
    'click',
    function (event) {
      if (!isDownloadControl(event.target)) return;
      run();
    },
    true
  );

  document.addEventListener('productCreate', run);
  document.addEventListener('viewCreate', run);
  document.addEventListener('fpdready', run);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', run);
  } else {
    run();
  }

  var ticks = 0;
  var timer = window.setInterval(function () {
    run();
    ticks += 1;
    if (ticks >= 12 || (getFpd() && viewInstances(getFpd()).length <= 1)) {
      window.clearInterval(timer);
    }
  }, 1000);
})();
